import {
  ADD_DRIVER_DOCUMENT,
  CLEAR_DRIVER_STATE,
  GET_CONFIG,
  GET_CONFIG_SUCCESS,
  GET_DRIVER,
  GET_DRIVERS,
  GET_DRIVERS_SUCCESS,
  GET_DRIVER_DETAILS,
  GET_DRIVER_DETAILS_SUCCESS,
  GET_DRIVER_SUCCESS,
  NEW_DRIVER,
  NEW_DRIVER_FAIL,
  NEW_DRIVER_SUCCESS,
  NEW_VEHICLE,
  NEW_VEHICLE_SUCCESS,
  NEW_VEHICLE_FAIL,
  NEXT_PAGE,
  PREV_PAGE,
  REMOVE_DRIVER_DOCUMENT,
  SET_DRIVER_ID,
  SET_NEW_DRIVER_ERR,
  SET_NEW_DRIVER_FIELD,
  CHANGE_DRIVER_STATUS,
  CHANGE_DRIVER_STATUS_SUCCESS,
} from "../../actions/driver/types";

const initialState = {
  config: [],
  configLoading: false,
  driverId: null,
  newDriverLoading: false,
  newVehicleLoading: false,
  newDriverData: {
    firstName: "",
    middleName: "",
    lastName: "",
    phoneNumber: "",
    photo: "",
    password: "",
    email: "",
    photoPreview: "",
    documents: [],
    vehicleId: null,
    vehicleModel: "",
    vehicleColor: "",
    vehiclePlateNumber: "",
    vehicleMakeYear: "",
    vehicleChannel: "",
  },
  newDriverErrors: {
    firstNameErr: "",
    middleNameErr: "",
    lastNameErr: "",
    phoneNumberErr: "",
    photoErr: "",
    passwordErr: "",
    emailErr: "",
    photoPreviewErr: "",
    documentErrors: [],
    vehicleLibreErr: "",
    vehicleModelErr: "",
    vehicleColoErrr: "",
    vehiclePlateNumberErr: "",
    vehicleMakeYearErr: "",
    vehicleChannelErr: "",
  },
  page: 1,
  drivers: [],
  driverDetails: null,
  driverDetailsLoading: false,
  changeDriverStatusLoading:false,
  count: 0,
  driversLoading: false,
};

export const driver = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CONFIG:
      return {
        ...state,
        configLoading: true,
      };
    case GET_CONFIG_SUCCESS:
      return {
        ...state,
        config: payload,
        configLoading: false,
      };
    case GET_DRIVERS:
      return {
        ...state,
        drivers:[],
        driversLoading: true,
      };
    case GET_DRIVERS_SUCCESS:
      return {
        ...state,
        drivers: payload.results,
        count: payload.count,
        driversLoading: false,
      };

    case CHANGE_DRIVER_STATUS:
      return {
        ...state,
        changeDriverStatusLoading: true,
      };
    case CHANGE_DRIVER_STATUS_SUCCESS:
      return {
        ...state,
        changeDriverStatusLoading: false,
      };

    case GET_DRIVER_DETAILS:
      return {
        ...state,
        driverDetailsLoading: true,
        driverDetails: null,
      };
    case GET_DRIVER_DETAILS_SUCCESS:
      return {
        ...state,
        driverDetails: payload,
        driverDetailsLoading: false,
      };

    case SET_NEW_DRIVER_FIELD:
      return {
        ...state,
        newDriverData: { ...state.newDriverData, ...payload },
      };
    case ADD_DRIVER_DOCUMENT:
      return {
        ...state,
        newDriverData: {
          ...state.newDriverData,
          documents: [...state.newDriverData.documents, payload],
        },
      };
    case REMOVE_DRIVER_DOCUMENT:
      let documents = state.newDriverData.documents;
      let filteredDocuments = documents.filter(
        (document) => document.id !== payload
      );
      return {
        ...state,
        newDriverData: {
          ...state.newDriverData,
          documents: filteredDocuments,
        },
      };

    case SET_NEW_DRIVER_ERR:
      return {
        ...state,
        newDriverErrors: { ...state.newDriverErrors, ...payload },
      };
    case SET_DRIVER_ID:
      return {
        ...state,
        driverId: payload,
      };

    case NEXT_PAGE:
      if (state.page === 3) return state;
      return {
        ...state,
        page: state.page + 1,
      };
    case PREV_PAGE:
      if (state.page === 1) return state;
      return {
        ...state,
        page: state.page - 1,
      };
    case NEW_DRIVER:
      return {
        ...state,
        newDriverLoading: true,
      };
    case NEW_DRIVER_SUCCESS:
      return {
        ...state,
        newDriverLoading: false,
        driverId: payload,
      };
    case NEW_DRIVER_FAIL:
      return {
        ...state,
        newDriverLoading: false,
        newDriverErrors: { ...state.newDriverErrors, phoneNumberErr: payload },
      };
    case NEW_VEHICLE:
      return {
        ...state,
        newVehicleLoading: true,
      };
    case NEW_VEHICLE_SUCCESS:
      return {
        ...state,
        newVehicleLoading: false,
      };
    case NEW_VEHICLE_FAIL:
      return {
        ...state,
        newVehicleLoading: false,
        newDriverErrors: {
          ...state.newDriverErrors,
          vehiclePlateNumberErr: payload,
        },
      };
    case CLEAR_DRIVER_STATE:
      return {
        ...initialState,
      };

    default: {
      return state;
    }
  }
};
